export const CLEAR_ALLSTATE = "CLEAR_ALLSTATE";

/* config module */
export const SET_CONFIGSETAE = "SET_CONFIGSETAE"; // 设置state数据
export const GET_CONFIGSETAE = "GET_CONFIGSETAE"; // 获取state数据
export const SET_BASECONFIG = "SET_BASECONFIG";
export const GET_BASECONFIG = "GET_BASECONFIG";
export const SET_COMMONSERVICE = "SET_COMMONSERVICE";
export const GET_COMMONSERVICE = "GET_COMMONSERVICE";
export const SET_COMMONCONFIG = "SET_COMMONCONFIG";
export const GET_COMMONCONFIG = "GET_COMMONCONFIG";
/* user module */
export const SET_USERSETAE = "SET_USERSETAE"; // 设置state数据
export const GET_USERSETAE = "GET_USERSETAE"; // 获取state数据
export const SET_USERINFO = "SET_USERINFO"; //
export const SET_ROLELIST = "SET_ROLELIST"; //
export const GET_USERINFO = "GET_USERINFO"; //
export const GET_ROLELIST = "GET_ROLELIST"; //
export const SET_USERLOGIN = "SET_USERLOGIN"; //
export const GET_USERLOGIN = "GET_USERLOGIN"; //
export const CLEAR_USERSSTATE = "CLEAR_USERSSTATE"; //

/* order module */
export const SET_ORDERSETAE = "SET_ORDERSETAE"; // 设置state数据
export const GET_ORDERSETAE = "GET_ORDERSETAE"; // 获取state数据

/* uniform module */
export const SET_FORMSETAE = "SET_FORMSETAE"; // 设置state数据
export const GET_FORMSETAE = "GET_FORMSETAE"; // 获取state数据
export const FILTER_FORMLIST = "FILTER_FORMLIST"; // 筛选list数据
export const EDIT_FORMLIST = "EDIT_FORMLIST"; // 编辑list数据
export const DEL_FORMLIST = "DEL_FORMLIST"; // 删除list数据
